module.exports = __webpack_public_path__ + "img/blockS3-card4.2633781a.jpg";